import axios from "axios";
import { getToken } from './auth'

// Déterminer l'URL de base en fonction de l'environnement
const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // En production, utilisez l'URL relative pour éviter les problèmes CORS
    // puisque tout sera servi depuis le même domaine grâce à Caddy
    // return '/api';
    return process.env.VUE_APP_NEST_API_BASE_URL || 'http://multitrade.space:3003';


  } else {
    // En développement, utilisez l'URL complète définie dans les variables d'environnement
    return process.env.VUE_APP_NEST_API_BASE_URL || 'http://multitrade.localhost:3003';
  }
};

// Création d'une instance axios spécifique pour le backend NestJS
const axiosNest = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token d'authentification si nécessaire
axiosNest.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Intercepteur pour gérer les erreurs de réponse
axiosNest.interceptors.response.use(
  response => response,
  error => {
    // Gestion des erreurs selon l'environnement
    if (process.env.NODE_ENV === 'production') {
      // En production, évitez de montrer les détails des erreurs
      console.error('Erreur API');
    } else {
      // En développement, affichez plus de détails
      console.error('Erreur API NestJS:', error);
    }
    return Promise.reject(error);
  }
);

export default {
  post(url, data) {
    return axiosNest.post(url, data);
  },
  get(url) {
    return axiosNest.get(url);
  },
  put(url, data) {
    return axiosNest.put(url, data);
  },
  delete(url) {
    return axiosNest.delete(url);
  }
}